import { v4 as uuidv4 } from 'uuid';
import config from '../config';

// Function to generate a slug from name and company
export const generateSlug = (name, company) => {
  const nameSlug = (name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  const companySlug = (company || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  // Generate a short, random string to ensure uniqueness
  const randomString = uuidv4().split('-')[0];

  let slug = `${nameSlug}`;
  if (companySlug) {
      slug += `-${companySlug}`;
  }
  slug += `-${randomString}`;
  
  return slug;
};

// Function to generate public URL
export const generatePublicUrl = (slug) => {
  // Use frontend URL for sharing/QR
  const frontendUrl = getFrontendUrl();
  return `${frontendUrl}/card/${slug}`;
};

// Function to generate QR code value
export const getQRCodeValue = (slug) => {
  return generatePublicUrl(slug);
};

export const getBackendUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || config.getBaseUrl();
};

export const getFrontendUrl = () => {
    // Use the configured frontend URL from config
    return process.env.REACT_APP_FRONTEND_URL || config.frontendUrl;
};

export const getFullUrl = (relativePath) => {
  if (!relativePath) return null;
  
  // If it's a blob URL, return as is
  if (relativePath.startsWith('blob:')) {
    return relativePath;
  }

  // If it's a full URL, extract just the path portion
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    try {
      const url = new URL(relativePath);
      relativePath = url.pathname;
    } catch (e) {
      console.error('Invalid URL:', relativePath);
      return relativePath;
    }
  }

  const backendUrl = getBackendUrl();
  // Ensure we don't have double slashes
  return `${backendUrl.replace(/\/$/, '')}/${relativePath.replace(/\\/g, '/').replace(/^\//, '')}`;
};